import React from "react";
import { TwitterShareButton, TwitterIcon } from "react-share";

const TwitterShare = (props) => {
  let url = props.url !== undefined ? props.url : "http://demo.merorug.com";
  let title =
    props.title !== undefined
      ? props.title
      : "Merorug: Weaving Your Dream Carpet";
  return (
    <TwitterShareButton url={url} title={title}>
      <TwitterIcon size={30} />
    </TwitterShareButton>
  );
};

export default TwitterShare;
